"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioGroup_1 = require("./RadioGroup");
exports.default = RadioGroup_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/index.js
// module id = 434
// module chunks = 8